require('jQuery.serializeObject');
import Inputmask from 'inputmask';

const debounce = require('lodash.debounce');

export default ($container) => {
    // Number porting toggling
    $(':input[name="NumberPorting[Active]"]', $container).on('change', debounce(function(e) {
        const $porting = $(this).closest('.js-number-porting');
        const $form    = $porting.closest('form');
        const $loader  = $form.find('.loader');
        $porting.prepend($loader.clone());
        $porting.addClass('loading');

        const data      = $porting.closest('form').serializeObject();
        data['_method'] = 'POST';

        $.ajax({
            url:    window.app.urls.checkoutNumberPorting,
            data:   data,
            method: 'POST'
        }).done(function(data) {
            const $content = $(data);
            $porting.replaceWith($content);
            window.app.loadComponentsFor($content);
        }).fail((xhr) => {
            $porting.removeClass('loading');
            if (xhr.statusText === 'abort') {
                return;
            }
            alert('Er ging iets mis met het versturen. Herlaad de pagina en probeer het opnieuw.');
        });
    }, 10));

    // Identification type toggling
    $(':input[name$="[Identification][Type]"]', $container).on('change', function(e) {
        $('[data-identification-type]').hide();
        $(`[data-identification-type="${$(this).val()}"]`).show();
    }).trigger('change');

    // Input mask for initials
    $(':input[name$="[Initials]"]', $container).each(function() {
        Inputmask('(A.){+}').mask($(this)[0]);
    });
}
